import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../actions'
import conf from '../../config/config'
import { doTrack } from '../../helpers/TaggingSerializer'

import './ManageArgosCard.scss'

import LoadingError from '../../components/LoadingError/LoadingError'
import Sidebar from '../../components/Sidebar/Sidebar'
import Meta from '../../components/Meta/Meta'
import CardLinks from '../../components/CardLinks/CardLinks'
import FAQAccordions from '../../components/FAQAccordions/FAQAccordions'
import StarRating from '../../components/StarRating/StarRating'
import LiveChat from '../../components/LiveChat/LiveChat'
import SearchBar from '../../components/SearchBar/SearchBar'
import HelpLink from '../../components/HelpLink/HelpLink'

class ManageArgosCard extends PureComponent {
  static waitForDataServer (dispatch, params, req, res) {
    return Promise
      .all([
        dispatch(actions.fetchSidebarNav(true)),
        dispatch(actions.fetchPageContent('manage-argos-card', true))
      ])
      .then(([sidebar, page]) => {
        if (page.payload.id === 0) {
          res.statusCode = 404
        }
      })
  }

  static waitForDataClient (store) {
    return (nextState, transition, callback) => {
      const { dispatch, getState } = store
      const state = getState()
      const page = state.page.page

      if (page && page.permalink === '/help/argos-card/manage') {
        return callback()
      }

      dispatch(actions.fetchPageContent('manage-argos-card'))
        .then(() => { callback() })
        .catch(() => { callback() })
    }
  }

  componentDidMount () {
    const { actions, sidebar } = this.props

    if (!sidebar.length) actions.fetchSidebarNav()
    this.fireAnalytics()
  }

  fireAnalytics = () => {
    if (window.digitalData) {
      window.digitalData.page.pageInfo.pageName = 'ar:help:page:manageargoscard'
      window.digitalData.page.pageInfo.templateTitle = 'help_PAGE_manageargoscard'
    }

    doTrack('help_initialLoad')
  }

  render () {
    const { sidebar, page, error } = this.props
    const imgDir = conf.IMG_DIR + '/argos-card'

    if (!page || error) return <LoadingError />

    return (
      <div id='page-manage-argoscard' className='helpfaq page page-manage-argoscard'>
        <div id='helpfaqcontent' tabIndex='-1' />

        <Meta pagemeta={page} />

        <div className='container sticky-nav'>
          <div className='xs-row xs-row--negative'>
            <Sidebar activePage='/help/argos-card/manage' links={sidebar} sticky />
          </div>
        </div>

        <div className='argoscard-content font-standard sticky-content'>
          <div className='container'>
            <div className='xs-row xs-row--negative'>
              <div className='xs-12 lg-9 lg-3-offset content'>
                <h1 className='h1 title'>Manage your Argos Card</h1>
                <p>Secure 24/7 access to view and manage your Argos Card account. Not got an Argos Card yet? <br className='xs-hidden md-block' /> <HelpLink href='/help/argos-card/' className='a'>Apply today</HelpLink> for a more flexible way to shop with us.</p>
              </div>

              <div className='xs-12 lg-9 lg-3-offset'>
                <div className='app-section'>
                  <h2 className='h2 section-title'>Speedy, simple, secure - My Argos Card app</h2>

                  <div className='argoscard-app' />
                  <p className='intro'>Looking after your Argos Card is as easy as 1,2,3...</p>
                  <ul className='list-numbered'>
                    <li>Download the App</li>
                    <li>Register your Argos Card</li>
                    <li>Start managing your Card right away</li>
                  </ul>
                  <div className='app-images'>
                    <a className='app-images__link' href='https://itunes.apple.com/gb/app/my-argos-card/id1084431321?mt=8' target='_blank'>
                      <img className='app-images__image app-images__image--ios' alt='ios' src={`${imgDir}/app-apple-prompt.png`} />
                    </a>
                    <a className='app-images__link' href='https://play.google.com/store/apps/details?id=com.homeretailgroup.myargoscard&hl=en_GB' target='_blank'>
                      <img className='app-images__image app-images__image--android' alt='android' src={`${imgDir}/app-google-prompt.png`} />
                    </a>
                  </div>
                  <h3 className='h3 xs-hidden md-block'>Once you've got the App, you can...</h3>
                  <h3 className='h3 md-hidden'>You can...</h3>
                  <ul className='list-ticks'>
                    <li>Keep track of your credit plans</li>
                    <li>See when your payments are due</li>
                    <li>Set up account alerts</li>
                    <li>Update your credit limit*</li>
                    <li>View your recent transactions</li>
                    <li>Make payments to your credit plans</li>
                  </ul>
                  <p className='terms font-base--small'>*Credit limit changes subject to account status</p>
                </div>
              </div>
            </div>
          </div>

          <div className='web-section'>
            <div className='container'>
              <div className='xs-row xs-row--negative'>
                <div className='xs-12 lg-9 lg-3-offset'>
                  <h2 className='h2 section-title'>Your account, your way - myargoscard.co.uk</h2>
                  <div className=' md-row'>
                    <div className='md-6 md-6--none'>
                      <div className='argoscard-web' />
                      <p className='caption'>It's simple and easy to use the Argos Card website (<a className='a' href='https://www.myargoscard.co.uk' target='_blank'>myargoscard.co.uk</a>)</p>
                    </div>
                    <div className='md-6 md-6--none'>
                      <h3 className='web-section__title h3'>Things you can do...</h3>
                      <ul className='list-ticks'>
                        <li>Check your balance</li>
                        <li>Make payments to your credit plans</li>
                        <li>See your statements</li>
                        <li>Set up a direct debit</li>
                        <li>Go paperless</li>
                        <li>Stay on top of your transactions</li>
                        <li>Update your credit limit<sup>*</sup></li>
                        <li>Keep your details up-to-date</li>
                      </ul>
                      <p className='font-base--small terms'>*Credit limit changes subject to account status</p>
                      <a href='https://www.myargoscard.co.uk/' className='button-link button-link--large' target='_blank'>My Argos Card</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='container'>
            <div className='xs-row xs-row--negative'>
              <div className='xs-12 lg-9 lg-3-offset'>
                <div className='phone-section'>
                  <h2 className='h2 section-title'>We're just a phonecall away</h2>
                  <div className='md-row'>
                    <div className='md-6 md-6--none'>
                      <h3 className='h3 xs-hidden md-block'>Things you can do on the phone...</h3>
                      <h3 className='h3 md-hidden'>You can...</h3>
                      <ul className='list-ticks'>
                        <li>Check your balance</li>
                        <li>Make payments</li>
                        <li>Set up a direct debit</li>
                        <li>Keep your details up-to-date</li>
                      </ul>
                    </div>
                    <div className='md-6 md-6--none'>
                      <h3 className='h3'>Grab your Argos Card. Then call us on.....</h3>
                      <p className='number'><a href='tel:03456400700'>03456 400 700</a></p>
                    </div>
                    <p className='terms'>
                      Credit subject to status. Argos Limited is authorised and regulated by the Financial Conduct Authority as a credit broker, and works exclusively for the lender, Home Retail Group Card Services Limited.&nbsp;
                      <a className='underline' href='http://www.argos.co.uk/webapp/wcs/stores/servlet/ArgosFSTermsConditionsView?storeId=10151&langId=110' target='_blank'>Terms & conditions apply</a>
                    </p>
                  </div>
                </div>

                <CardLinks />

                <FAQAccordions faqs={page.related_faqs} />

                <StarRating pageId={page.id} />

                <LiveChat
                  actions={this.props.actions}
                  chatHasEnded={this.props.chatHasEnded}
                  chatLoading={this.props.chatLoading}
                  chatOnline={this.props.chatOnline}
                />

                <SearchBar position='bottom' />
              </div>
            </div>
          </div>

        </div>

      </div>
    )
  }
}

ManageArgosCard.propTypes = {
  sidebar: PropTypes.array,
  page: PropTypes.object,
  error: PropTypes.bool,
  actions: PropTypes.object,
  chatHasEnded: PropTypes.bool,
  chatLoading: PropTypes.bool,
  chatOnline: PropTypes.bool
}

function mapStateToProps (state) {
  return {
    sidebar: state.help.sidebar,
    page: state.page.page,
    error: state.page.pageError,
    chatHasEnded: state.page.chatHasEnded,
    chatLoading: state.page.chatLoading,
    chatOnline: state.page.chatOnline
  }
}

function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageArgosCard)
